import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import SelectChildDjs from 'components/common/SelectChildDjs';
import { useEventsFilterable } from '../../../EventsListContext';

import { SimpleOption } from 'vibo-ui/Select';
import { SessionStorageKeys } from 'types/enums';

const DjsColumn: FC<ColumnProps> = () => {
  const { t } = useTranslation();
  const { filter, setFilter } = useEventsFilterable();

  const handleChangeDjId = ({ value: djId }: SimpleOption) => {
    djId
      ? sessionStorage.setItem(SessionStorageKeys.eDj, djId)
      : sessionStorage.removeItem(SessionStorageKeys.eDj);

    setFilter((prev: EventsFilter) => ({
      ...prev,
      djId,
    }));
  };

  return (
    <div className="djsColumn">
      <span className="label">{t('dj', { count: !!filter.djId ? 1 : 2 })}</span>
      <SelectChildDjs djId={filter.djId} onChange={handleChangeDjId} />
    </div>
  );
};

export default DjsColumn;
